import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { log } from '../../utils/logger'
import './Anketa.css'

export const Feedback: React.FC = () => {
    const { isAuthenticated } = useAuth()
    const navigate = useNavigate()
    const [endpointAddress, setEndpointAddress] = useState('')
    const [text, setText] = useState('')
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        fetch('/config.json')
            .then(res => res.json())
            .then(config => {
                if (config['endpoint-address']) {
                    setEndpointAddress(config['endpoint-address'])
                }
                log('Feedback', 'Загружен config', { hasEndpoint: !!config['endpoint-address'] })
            })
            .catch(err => log('Feedback', 'Ошибка загрузки config', err))
    }, [])

    const handleSubmit = async () => {
        setError('')
        setSuccess('')

        if (!isAuthenticated) {
            setError('Для отправки сообщения необходимо войти в аккаунт.')
            return
        }
        const trimmed = text.trim()
        if (!trimmed) {
            setError('Введите текст сообщения.')
            return
        }
        if (!endpointAddress) {
            setError('Сервис временно недоступен.')
            return
        }

        const id = localStorage.getItem('id')
        const token = localStorage.getItem('token')
        if (!id || !token) {
            setError('Сессия истекла. Пожалуйста, войдите в аккаунт заново.')
            return
        }

        setSubmitting(true)
        try {
            const res = await fetch(`${endpointAddress}/sendFeedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, token, text: trimmed }),
            })
            const data = await res.json().catch(() => ({}))
            log('Feedback', 'Ответ sendFeedback', { status: res.status, data })

            if (data.status === '1') {
                setSuccess('Сообщение успешно отправлено. Спасибо за обратную связь!')
                setText('')
                return
            }
            setError(data.message || 'Не удалось отправить сообщение. Попробуйте позже.')
        } catch (err) {
            log('Feedback', 'Ошибка отправки', err)
            setError('Ошибка соединения. Попробуйте позже.')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="anketa-container">
            <div className="anketa-card">
                <div className="question-section">
                    <h2 className="question-text">Обратная связь</h2>
                    <p className="question-hint">
                        Напишите нам сообщение, если у вас есть вопросы, предложения или вы хотите оставить отзыв о работе сервиса.
                    </p>
                </div>

                <div className="form-section">
                    <div className="form-group">
                        <label>Сообщение</label>
                        <textarea
                            className="textarea-input"
                            placeholder="Опишите ваш вопрос или предложение..."
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            rows={6}
                        />
                    </div>
                    {error && (
                        <div className="field-error" style={{ marginTop: '0.5rem' }}>
                            {error}
                        </div>
                    )}
                    {success && (
                        <div
                            style={{
                                marginTop: '0.5rem',
                                color: 'var(--success, #22c55e)',
                                fontSize: '0.9rem',
                            }}
                        >
                            {success}
                        </div>
                    )}
                </div>

                <div className="navigation-section" style={{ justifyContent: 'space-between' }}>
                    <button
                        className="nav-btn prev-btn"
                        type="button"
                        onClick={() => navigate('/')}
                    >
                        ← На главную
                    </button>
                    <button
                        className="nav-btn submit-btn"
                        type="button"
                        disabled={submitting}
                        onClick={handleSubmit}
                    >
                        {submitting ? 'Отправка...' : 'Отправить'}
                    </button>
                </div>
            </div>
        </div>
    )
}

